"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
require("./SendReceiveConfirmHeader.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('send-receive-confirm-header');
var SendReceiveConfirmHeader = function SendReceiveConfirmHeader(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("send"),
    t = _useTranslation.t;
  var isSend = props.isSend,
    _props$product = props.product,
    ProductFullName = _props$product.ProductFullName,
    Product = _props$product.Product,
    ProductSymbol = _props$product.ProductSymbol;
  var headerText = isSend ? "".concat(t("Send"), " ").concat(Product || ProductSymbol, " ").concat(ProductFullName) : "".concat(Product || ProductSymbol, " ").concat(ProductFullName, " ").concat(t("Request"));
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: isSend ? 'sendWithBorder' : 'receiveWithBorder',
    customClass: bemClasses('icon')
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('title')
  }, headerText));
};
SendReceiveConfirmHeader.propTypes = {
  product: _propTypes["default"].object.isRequired,
  isSend: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = SendReceiveConfirmHeader;